export default __webpack_public_path__ + "static/media/nextPage.f3d99e23.png";